import { OtherTheme, Theme } from '@api';

export const isTheme = (item: Theme | OtherTheme): item is Theme => {
  return 'theme_id' in item;
};

export const useThemeTypeColors = () => {
  return {
    Investment: 'var(--kg-theme)',
    Financial: 'var(--text-decorative-purple)',
    Macro: 'var(--text-decorative-teal)',
  };
};
